<div class="flex flex-col items-center justify-center h-[100vh] w-full p-4">
  <div class="flex flex-col items-center justify-center">
    <p>{{ 'MAINTENANCE_PAGE_DESCRIPTION' | translate }}</p>
  </div>
</div>
